<template>
  <div
    class="ml-2 points-gain"
    :class="{
      'animate__animated lb-fadeInLeft animate__fast': !animated
    }"
  >
    +{{ item.newPoint }}
    <span
      v-show="item.manualPoint"
      class="animate__animated animate__flash animate__delay-3s animate__repeat-3 animate__slow"
    >
      {{ item.manualPoint > 0 ? '+' : '' }}{{ item.manualPoint }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      animated: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.animated = true
    }, 2000)
  },
  destroyed() {
    this.animated = false
  },
}
</script>
